export enum OpenClosedStates {
  Open,
  Closed,
}
